<template>
    <base-lined-card
        class="product-listing-card"
        :to="to"
        :image="image"
        :title="name"
    >
        <div
            v-if="dietaryLabelsWithImage.length"
            class="dietary-labels"
            slot="media-header"
        >
            <ul>
                <li
                    v-for="dietaryLabel in dietaryLabelsWithImage"
                    :key="dietaryLabel.text"
                    v-test:dietaryLabel
                >
                    <span
                        class="sr-only"
                        v-test:dietaryLabelA11yText
                    >
                        this product is {{ dietaryLabel.text }}
                    </span>

                    <lazy-image
                        class="dietary-label-icon"
                        :src="dietaryLabel.image.src"
                        :alt="dietaryLabel.image.alt"
                        v-test:dietaryLabelIcon
                    />
                </li>
            </ul>
        </div>
        <p
            v-if="calories && calorieStats.includes(statToShow)"
            class="content"
            v-test:calories
        >
            {{ calories }} kcal
        </p>
        <p
            v-if="fibre && fibreStats.includes(statToShow)"
            class="content"
            v-test:fibre
        >
            {{ fibre }}g of fibre
        </p>
        <p
            v-if="protein && proteinStats.includes(statToShow)"
            class="content"
            v-test:protein
        >
            {{ protein }}g of protein
        </p>
        <p
            v-if="plantPoints && plantPointsStats.includes(statToShow)"
            class="content"
            v-test:plantPoints
        >
            {{ plantPoints }} plant points
        </p>
    </base-lined-card>
</template>

<script>
    import BaseLinedCard from '../BaseLinedCard/BaseLinedCard';

    export default {
        name: 'product-listing-card',

        components: { BaseLinedCard },

        props: {
            image: {
                type: Object,
                default: () => ({}),
            },

            name: {
                type: String,
                default: '',
            },

            calories: {
                type: [Number, String],
                default: 0,
            },

            fibre: {
                type: [Number, String],
                default: 0,
            },

            protein: {
                type: [Number, String],
                default: 0,
            },

            plantPoints: {
                type: [Number, String],
                default: 0,
            },

            statToShow: {
                type: String,
                default: 'calories',
            },

            to: {
                type: [String, Boolean],
                default: false,
            },

            dietaryLabels: {
                type: Array,
                default: () => ([]),
            },
        },

        data() {
            return {
                // Three different ways to sort the products
                calorieStats: ['calories', 'calories:asc', 'calories:desc'],
                fibreStats: ['fibre', 'fibre:asc', 'fibre:desc'],
                proteinStats: ['protein', 'protein:asc', 'protein:desc'],
                plantPointsStats: ['plant_points', 'plant_points:asc', 'plant_points:desc'],
            };
        },

        computed: {
            /**
             * Only return dietary labels which have an image.
             *
             * @returns {Array}
             */
            dietaryLabelsWithImage() {
                return this.dietaryLabels.filter(({ image }) => image?.src);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .base-lined-card {
        position: relative;
    }

    p {
        margin-bottom: 0;
    }

    .content {
        font-size: rem(14px);
        color: secondary-palette(5);
    }

    .dietary-labels {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 1;
        max-width: 100%;
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
    }

    li {
        margin-left: 6px;
    }

    .dietary-label-icon {
        height: 16px;
        width: auto;
    }
</style>
